import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }, { size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", { color: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ align: [] }],
  ["link"],
  ["clean"],
];

const FORMATS = [
  "header","size",
  "bold","italic","underline","color",
  "list",
  "align",
  "link",
];

/**
 * RichEditor — Quill-based rich text editor that fits the neon dark theme.
 * Persists & emits HTML.
 */
export default function RichEditor({ value, onChange, placeholder = "Write here…", testid }) {
  return (
    <div className="rich-editor-wrapper" data-testid={testid || "rich-editor"}>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={{ toolbar: TOOLBAR }}
        formats={FORMATS}
        placeholder={placeholder}
      />
    </div>
  );
}
